import * as Msal from "msal";

class AuthService {
    private msalInstance: Msal.UserAgentApplication;
    private request: Msal.AuthenticationParameters;
    private requestToken: Msal.AuthenticationParameters;

    public constructor() {
        const msalConfig: Msal.Configuration = {
            auth: {
                clientId: process.env.VUE_APP_AZURE_AD_B2C_CLIENTID,
                authority: `${process.env.VUE_APP_AZURE_AD_B2C_INSTANCE}/${process.env.VUE_APP_AZURE_AD_B2C_TENANTID}/${process.env.VUE_APP_AZURE_AD_B2C_USER_FLOW}`,
                validateAuthority: false,
                redirectUri: `${window.location.origin}${process.env.VUE_APP_AZURE_AD_B2C_CALLBACKPATH}`,
                navigateToLoginRequestUrl: true,
            },
            cache: {
                cacheLocation: "localStorage",
                storeAuthStateInCookie: false,
            },
        };

        this.request = {
            scopes: ["openid", "profile"],
        };

        this.requestToken = {
            scopes: [process.env.VUE_APP_AZURE_AD_B2C_TOKEN_PERMISSION],
        };

        this.msalInstance = new Msal.UserAgentApplication(msalConfig);
        this.msalInstance.handleRedirectCallback((error, response) => {
            if (!error) {
                this.msalInstance.acquireTokenSilent(this.request);
            }
        });
    }

    public login(): void {
        if (this.msalInstance) {
            this.msalInstance.loginRedirect(this.request);
        }
    }

    public logout(): void {
        if (this.msalInstance) {
            this.msalInstance.logout();
        }
    }

    public getAccount(): Msal.Account {
        if (this.msalInstance) {
            return this.msalInstance.getAccount();
        }
        return null;
    }

    public async getAccessToken(): Promise<string> {
        try {
            const response = await this.msalInstance.acquireTokenSilent(this.requestToken);
            if (response?.accessToken !== null) {
                return response.accessToken;
            } else {
                this.msalInstance.acquireTokenRedirect(this.requestToken);
            }
        } catch (error) {
            this.msalInstance.acquireTokenRedirect(this.requestToken);
        }
        return "";
    }
}

const authService = new AuthService();

export { AuthService, authService };
